import React, {useEffect, useState} from "react";
import useOnClickOutside from "use-onclickoutside";
import {useSelector} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";

import NavBar_HospitalSelector from "./NavBar_HospitalSelector";

const NavBar_HospitalMenu = () => {
    const {hospitals, selectedHospital} = useSelector(state => state.auth);
    const {selectedMenu, selectedMenu_subAction} = useSelector(state => state.main);
    const ref = React.useRef(null);
    const [popupVisible, setPopupVisible] = useState(false);
    useOnClickOutside(ref, () => setPopupVisible(false));

    const togglePopupMenu = () => setPopupVisible(!popupVisible);

    useEffect(() => {
        setPopupVisible(false);
    }, [selectedHospital])

    const conditions = {
        [actionTypes.MENU_BOOKING_LIST]: (h) => h.patient_booking_enable,
        [actionTypes.MENU_IFC_LOOKUP]: (h) => h.ifc_lookup_enable
    };

    const filteredHospitals = hospitals.filter(hospital =>
        conditions[selectedMenu] ? conditions[selectedMenu](hospital) : true
    );

    return (
        <div className="dropdown hospital-info-drop" ref={ref}>
            <button className="btn btn-white dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={togglePopupMenu}>
                {selectedHospital.title}
            </button>
            <div className={`dropdown-menu dropdown-menu-right${popupVisible ? ' show' : ''}`} aria-labelledby="dropdownMenuButton">
                {filteredHospitals.map(hospital => (
                    <NavBar_HospitalSelector hospital={hospital} key={hospital.id} />
                ))}
            </div>
        </div>
    );
}
export default NavBar_HospitalMenu;